// @ts-nocheck
import { Component, NO_ERRORS_SCHEMA } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { CandidateService } from '../services/candidate.service';
import { VendorService } from '../services/vendor.service';
import { UtilsDataService } from '../services/utils-data.service';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { HeaderLatestComponent } from '../home/landing-root/header-latest/header-latest.component';
import { PeopleflowFooterComponent } from '../peopleflow-footer/peopleflow-footer.component';
@Component({
  standalone: true,
  selector: 'app-immediate-hirings',
  templateUrl: './immediate-hirings.component.html',
  styleUrl: './immediate-hirings.component.scss',
  imports: [CommonModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, HeaderLatestComponent, PeopleflowFooterComponent],
  schemas: [NO_ERRORS_SCHEMA],
})
export class ImmediateHiringsComponent {
  [key: string]: any;
  constructor() {}

  ngOnInit() {}

  getAllJobAdverts() {}

  getBorderColor(index: number): string {}

  shuffleBorderColors() {}
}
